module.exports = __webpack_public_path__ + "img/black_left.1293dc2f.png";